export const Trash = () => (
  <g>
    <path
      d='M7.71459 16.5559C7.71572 16.9386 7.86655 17.3052 8.13413 17.5758C8.4017 17.8463 8.76429 17.9989 9.1427 18H14.8562C15.2346 17.9989 15.5972 17.8463 15.8648 17.5758C16.1324 17.3052 16.2832 16.9386 16.2843 16.5559V7.88925H7.71352L7.71459 16.5559ZM17 5.72258H14.4995L13.7849 5H10.2141L9.49946 5.72258H7V7.16667H16.9989L17 5.72258Z'
      fill='currentColor'
    />
  </g>
)
